import {
  AlertingRoutes,
  AuthRoutes,
  DashboardRoutes,
  ExploringRoutes,
  HelpRoutes,
  HomeRoutes,
  ManagingRoutes,
  PublicRoutes,
  ServicesRoutes,
  ShapingRoutes,
} from '@/model/Routes';

export const getAllRoutePaths = () => {
  const simpleRoutes = Object.values({ ...PublicRoutes, ...AuthRoutes });
  const routeObjects = Object.values({
    ...HomeRoutes,
    ...ServicesRoutes,
    ...DashboardRoutes,
    ...AlertingRoutes,
    ...ExploringRoutes,
    ...ShapingRoutes,
    ...ManagingRoutes,
    ...HelpRoutes,
  }).flatMap(({ route }) => route);

  return [...simpleRoutes, ...routeObjects];
};
